import React, { useState, useEffect } from "react";
import adminLogo from "../../../images/bg-login.jpg";
import EditProfileModal from "./EditProfileModal";
import UserServices from "../../../services/UserServices";
import Swal from "sweetalert2";

const AppProfile = () => {

    const [showEditModal, setShowEditModal] = useState(false);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchProfile = async () => {
        try {

            setLoading(true);

            const response =
                await UserServices.getMyProfile();

            console.log("Profile API", response?.data);

            setProfile(
                response?.data?.data
            );

            console.log(
                "Profile API",
                response.data
            );

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    if (loading) {
        return (
            <div className="text-center p-5">
                Loading...
            </div>
        );
    }

    const user = profile;


    return (
        <>
            <EditProfileModal
                show={showEditModal}
                handleClose={() => setShowEditModal(false)}
                user={profile}
                refreshData={fetchProfile}
            />
            <div >
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden ">
                    {/* Banner */}
                    <div
                        style={{
                            height: "225px",
                            backgroundImage: adminLogo ? `url(${adminLogo})` : "linear-gradient(to right, #4e54c8, #8f94fb)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    />

                    {/* Profile Section */}
                    <div className="card-body position-relative pt-4 ">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="d-flex align-items-center">
                                {/* Profile Image */}
                                {
                                    user?.photo ? (
                                        <img
                                            src={`https://indigoinfra.in//img/profileImage/${user.photo}`}
                                            alt="Profile"
                                            className="rounded-circle border border-4 border-white"
                                            style={{
                                                width: "90px",
                                                height: "90px",
                                                objectFit: "cover",
                                                marginTop: "-70px",
                                                background: "#fff",
                                            }}
                                        />
                                    ) : (
                                        <div
                                            className="rounded-circle border border-4 border-white d-flex align-items-center justify-content-center"
                                            style={{
                                                width: "90px",
                                                height: "90px",
                                                marginTop: "-70px",
                                                background: "#5BC8C8",
                                                color: "#fff",
                                                fontSize: "32px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {user?.name?.charAt(0)?.toUpperCase() || "U"}
                                        </div>
                                    )
                                }

                                {/* User Info */}
                                <div className="ms-4">
                                    <div className="d-flex flex-wrap align-items-center gap-5">
                                        <div>
                                            <h4 className="mb-1 text-primary">
                                                {user?.name || "John Doe"}
                                            </h4>
                                            <p className="mb-0 text-muted">
                                                {user?.role || "User Role"}
                                            </p>
                                        </div>

                                        <div>
                                            <h5 className="mb-1 text-dark">
                                                {user?.email || "hello@email.com"}
                                            </h5>
                                            <p className="mb-0 text-muted">
                                                Email
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Edit Button */}
                            <div className="ms-auto">
                                <i
                                    onClick={() => setShowEditModal(true)}
                                    className="bi bi-pencil-square text-primary"
                                    style={{
                                        fontSize: "24px",
                                        cursor: "pointer",
                                    }}
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card shadow-sm border-0 p-2">
                    <div className="card-header p-2">
                        <h5 className="mb-0">User Information</h5>
                    </div>

                    <div className="card-body p-2">
                        <div className="row g-2">
                            <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-person-circle fs-3 text-primary me-3"></i>
                                    <div>
                                        <small className="text-muted">Full Name</small>
                                        <h6 className="mb-0">{user?.name}</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-envelope-fill fs-3 text-success me-3"></i>
                                    <div>
                                        <small className="text-muted">Email</small>
                                        <h6 className="mb-0">{user?.email}</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-telephone-fill fs-3 text-info me-3"></i>
                                    <div>
                                        <small className="text-muted">Mobile Number</small>
                                        <h6 className="mb-0">{user?.mobileNo}</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-shield-lock-fill fs-3 text-warning me-3"></i>
                                    <div>
                                        <small className="text-muted">Role</small>
                                        <h6 className="mb-0 text-capitalize">{user?.role}</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-check-circle-fill fs-3 text-success me-3"></i>
                                    <div>
                                        <small className="text-muted">Status</small>
                                        <h6 className="mb-0 text-capitalize">{user?.status}</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div
                                    className="d-flex align-items-center"
                                    title={
                                        user?.store
                                            ?.map(
                                                store =>
                                                    `${store.name} (${store.location})`
                                            )
                                            .join("\n")
                                    }
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                        Swal.fire({
                                            title: "Assigned Stores",
                                            html: user?.store
                                                ?.map(
                                                    store =>
                                                        `${store.name} (${store.location})`
                                                )
                                                .join("<br/>"),
                                            icon: "info"
                                        })
                                    }
                                >
                                    <i className="bi bi-shop fs-3 text-danger me-3"></i>

                                    <div>
                                        <small className="text-muted">
                                            Total Stores
                                        </small>

                                        <h6 className="mb-0">
                                            {user?.store?.length || 0}
                                        </h6>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppProfile;